import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";

const routeMeta: Record<string, [string, string]> = {
  "/": [
    "Kyndo — Markets move. Good follows.",
    "Discover and create Base tokens with a permanent share of trading fees for a verified nonprofit.",
  ],
  "/market": [
    "Markets — Kyndo",
    "Find Base tokens and the causes they support. Explore market caps and permanent charity allocations.",
  ],
  "/launch": [
    "Create a token — Kyndo",
    "Create your token on Base and choose the cause it will support.",
  ],
  "/causes": [
    "Find a cause — Kyndo",
    "Explore verified nonprofits from the Donate.gg directory.",
  ],
  "/ledger": [
    "Impact ledger — Kyndo",
    "Inspect recorded charity releases and each token’s individual donation route on Base.",
  ],
  "/about": [
    "The idea — Kyndo",
    "Understand the fees, nonprofit routes and fresh Base deployment prepared for Kyndo.",
  ],
};

export function RouteExperience() {
  const location = useLocation();
  useEffect(() => {
    const [title, description] = routeMeta[location.pathname] ?? [
      "Market detail — Kyndo",
      "Trade a Base token and inspect its permanent nonprofit route.",
    ];
    document.title = title;
    [
      'meta[name="description"]',
      'meta[property="og:description"]',
      'meta[name="twitter:description"]',
    ].forEach((selector) =>
      document.querySelector(selector)?.setAttribute("content", description)
    );
    ['meta[property="og:title"]', 'meta[name="twitter:title"]'].forEach(
      (selector) =>
        document.querySelector(selector)?.setAttribute("content", title)
    );
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [location.pathname]);
  return (
    <div className="route-stage" key={location.pathname}>
      <Outlet />
    </div>
  );
}
